export enum ViewLayout {
    HORIZONTAL = "horizontal",
    VERTICAL = "vertical",
    GRID = "grid",
}
